/**
 * Posts tagged with this value are treated as testimonial stories:
 * they are hidden from /blog and listed on /testimonials, and they are
 * served from the root path (e.g. /desiree-doubled-her-business).
 */
export const TESTIMONIAL_TAG = "testimonials";

export function isTestimonialPost(tags?: string[] | null) {
  return (tags ?? []).some((t) => t.toLowerCase() === TESTIMONIAL_TAG);
}
